import { render, staticRenderFns } from "./Socio-noregister.vue?vue&type=template&id=029d2856&scoped=true&"
import script from "./Socio-noregister.vue?vue&type=script&lang=js&"
export * from "./Socio-noregister.vue?vue&type=script&lang=js&"
import style0 from "./Socio-noregister.vue?vue&type=style&index=0&id=029d2856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029d2856",
  null
  
)

component.options.__file = "Socio-noregister.vue"
export default component.exports